<template>
  <div class="welcome-overlay">
    <div class="welcome-container">
      <h2>환영합니다.</h2>
      <p>
        서비스 체험을 위한 <strong>2000 LYD</strong>가 지급되었습니다.<br />
        더 많은 무료 체험은 <strong>‘인생의 역점 무료 채널’</strong> 메뉴를 확인하세요.    
      </p>
      <button @click="proceed">시작하기</button>
    </div>
  </div>
</template>

<script setup>
  import { inject, ref, onMounted, watch } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from 'vuex'
  import { doc, setDoc } from 'firebase/firestore'
  import { db } from '@/firebase' // Firestore 인스턴스 import
  import { generateCode, generateGuestName } from '@/utils/utils.js'
  import { getGanjiByYear } from '@/utils/utils.js'
  import { rewardUser } from '@/utils/setReward.js'

  const router = useRouter()
  const store = useStore()
  
  const guestLydia = ref(0)
  guestLydia.value = Number(import.meta.env.VITE_GUEST_LYDIA)

  const accessCode = ref('')

  const showToast = inject('showToast')

  onMounted(() => {
    accessCode.value = localStorage.getItem('accessToken')
    if (accessCode.value) {
      router.replace('/IChingDaily')
    }
  })

  const proceed = async () => {
    if (accessCode.value) router.replace('/IChingDaily')

    const accessToken = generateCode(30)
    const guestName = generateGuestName()
    const guestLydia = Number(import.meta.env.VITE_GUEST_LYDIA)
    const referrer = localStorage.getItem('referrer') || ''

    await setDoc(doc(db, 'users', accessToken), {
      name: guestName,
      lydia: guestLydia,
      referrer,
      createdAt: new Date().toISOString(),
    }, { merge: true })
    localStorage.setItem('accessToken', accessToken)

    if (referrer) {
      await rewardUser(
        store,
        'refJoin',
        {
          referredUser: accessToken,
          referrer,
        },
        showToast,
      )
    }

    // Vuex store에 사용자 정보 업데이트 (initializeAuth 액션 호출 또는 직접 commit)
    await store.dispatch('initializeAuth')

    router.push('/IChingDaily')
  } 
  
</script>

<style scoped>
  .welcome-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: var(--device-width);
    max-width: 480px; /* 최대 너비 설정 */
    margin: auto;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* 다른 요소 위에 표시 */
  }

  .welcome-container {
    background-color: white;
    padding: 1rem; /* SetupUserData.vue와 유사하게 2rem 사용 */
    border-radius: 12px; /* SetupUserData.vue와 유사하게 12px 사용 */
    text-align: center;
    width: 90%;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2); /* 그림자 추가 */
    color: #333; /* SetupUserData.vue와 유사하게 텍스트 색상 설정 */
  }

  .welcome-container h2 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: var(--font-size-12);
    color: #333;
  }

  .welcome-container p {
    margin-bottom: 1rem;
    font-size: var(--font-size-10);
    color: #555;
  }

  button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    background-color: #4caf50;
    color: white;
    cursor: pointer;
    align-self: center;
  }

  button:hover {
    background-color: #45a049;
  }
</style>
